import React from 'react';
import { Modal, Box, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
const PDFJS_VERSION = "2.16.105";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        backgroundColor: 'white',
        padding: theme.spacing(2),
        borderRadius: '8px',
        position: 'relative',
        width: '90%',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: '#006ac6',
        zIndex: 1,
    },
    pdfContainer: {
        flex: 1,
        overflow: 'hidden',
        marginTop: theme.spacing(2),
        '& .rpv-core__viewer': {
            height: '100%',
        },
    },
}));

const PDFViewerModal = ({ open, onClose, pdfUrl }) => {
    const classes = useStyles();
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            aria-labelledby="pdf-viewer-modal"
        >
            <Box className={classes.modalContent}>
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
                <div className={classes.pdfContainer}>
                    <Worker 
					workerUrl={`https://unpkg.com/pdfjs-dist@${PDFJS_VERSION}/legacy/build/pdf.worker.js`}
                    >
                        <Viewer
                            fileUrl={pdfUrl}
                            plugins={[defaultLayoutPluginInstance]}
                            defaultScale={1}
                        />
                    </Worker>
                </div>
            </Box>
        </Modal>
    );
};

export default PDFViewerModal; 